import { IMG_URL } from './constants';

// Format price to INR
export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
  }).format(price);
};

// Get image URL - matches mobile app pattern
export const getImageUrl = (imagePath) => {
  if (!imagePath) return '/assets/images/placeholder.jpg';
  if (imagePath.startsWith('http')) return imagePath;
  // IMG_URL already ends with /, so just concatenate
  return `${IMG_URL}${imagePath}`;
};

// Format course name for URL
export const formatCourseUrl = (courseName) => {
  return courseName.toLowerCase().replace(/\s+/g, '-');
};

// Parse course name from URL
export const parseCourseUrl = (urlName) => {
  return urlName.replace(/-/g, ' ');
};

// Validate email
export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

// Validate phone
export const isValidPhone = (phone) => {
  const phoneRegex = /^[6-9]\d{9}$/;
  return phoneRegex.test(phone);
};

// Format date
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return new Date(dateString).toLocaleDateString('en-IN', options);
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
};

// Get YouTube video ID
export const getYouTubeVideoId = (url) => {
  if (!url) return null;
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : null;
};

// Debounce function
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

